var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gr",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 0h512v57H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 57h512v57H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 114h512v57H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 171h512v57H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 228h512v56.9H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 284.9h512v57H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 341.9h512v57H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 398.9h512v57H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    d: "M0 0h284.9v284.9H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 0h57v284.9h-57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114h284.9v57H0z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 455h512v57H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.1dddf280747af1d2491114ff2ef95c89.svg";
export { ForwardRef as ReactComponent };